import React, { useEffect, useState, useRef } from "react";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import CenterModal from "../Components/CenterSelectorModal";
import API from '../Services/Report'
import "bootstrap-icons/font/bootstrap-icons.css";
import * as XLSX from "xlsx";
import moment from "moment";
const PartyReport = () => {
    const [selectedCenter, setSelectedCenter] = useState([]);
    const today = new Date();
    const formattedToday = today.toISOString().split("T")[0];
    const pastDate = new Date();
    pastDate.setDate(pastDate.getDate() - 90);
    const formattedPastDate = pastDate.toISOString().split("T")[0];
    const [partySummary, setPartySummary] = useState({})
    const tableRef = useRef(null);
    const [detailReport, setDetailReport] = useState([])
    const [showDetailTable, setShowDetailTable] = useState(false);
    const [showDetailTable1, setShowDetailTable1] = useState(false);
    const [showDetailPartyDump, setShowDetailPartyDump] = useState(false);
    const [totalPages, setTotalPages] = useState(1);
    const [totalPages1, setTotalPages1] = useState(1);

    const [totalRecord, setTotalRecord] = useState(0);
    const [totalRecord1, setTotalRecord1] = useState(0);
    const [totalRecordPartyDump, setTotalRecordPartyDump] = useState(0);

    const [recordsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [partyId, setPartyId] = useState("")
    const [partyData, setPartyData] = useState([])
    const [reportType, setReportType] = useState("party");
    const [partyEventReport, setPartyEventReport] = useState([])
    const [partyDumpData, setPartyDumpData] = useState([])
    const [resetTrigger, setResetTrigger] = useState(0);
    const [currentPageDump, setCurrentPageDump] = useState(1);
    const [totalPagesDump, setTotalPagesDump] = useState(1);
    const [pageForDump, setPageForDump] = useState(1);
    const [mobile, setMobile] = useState("");
    const [search, setSearch] = useState({
        searchText: "",
        // from_date: "",
        // to_date: "",
        from_date: formattedToday,
        to_date: formattedToday,
    });

    // useEffect(() => {
    //     if (selectedCenter && selectedCenter.length > 0) {
    //         getPartSummartData();
    //         getDetailReportData(1);
    //         getPartyDumpReportData(1)
    //     }
    // }, [selectedCenter]);

    useEffect(() => {
    loadInitialData();
}, []);
const loadInitialData = () => {
    getPartSummartData();
    getDetailReportData(1);
};

    useEffect(() => {
        if (reportType === "party") {
            getDetailReportData(1);
            setShowDetailTable(true);
            setShowDetailTable1(false);
            setShowDetailPartyDump(false)

        } else if (reportType === "celebrated") {
            getCelebratedReportData(1);
            setShowDetailTable(false);
            setShowDetailTable1(true)
            setShowDetailPartyDump(false)
        }
        else if (reportType === "partydump") {
            getPartyDumpReportData(1);
            setShowDetailTable(false);
            setShowDetailTable1(false)
            setShowDetailPartyDump(true);
        }
    }, [reportType]);

    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;

        if (fieldName === "from_date") {
            const newToDate = moment(value).add(90, "days");

            const finalToDate = newToDate.isAfter(moment())
                ? moment().format("YYYY-MM-DD")
                : newToDate.format("YYYY-MM-DD");

            setSearch((prev) => ({
                ...prev,
                from_date: value,
                to_date: finalToDate
            }));
        } else {
            setSearch((prev) => ({
                ...prev,
                [fieldName]: value
            }));
        }
    };

    const handleSelectedCenter = (selectedData) => {
        setSelectedCenter(selectedData);
    };

    const getPartSummartData = async () => {
        try {
            const response = await API.getPartyReport();
            setPartySummary(response?.data?.result || {});
        } catch (error) {
            console.error("Error fetching party report:", error);
        }
    };

    const getDetailReportData = async (page = 1) => {
        // setShowDetailTable(true);
        try {
            const centerlist = Array.isArray(selectedCenter)
                ? selectedCenter.join(",")
                : selectedCenter;
            const payload = {
                page_number: page,
                page_size: recordsPerPage,
                start_date: search.from_date || formattedToday,
                end_date: search.to_date || formattedToday,
                center_ids: centerlist && centerlist.length > 0 ? centerlist : null,
            };
            const response = await API.getDetailReport(payload);
            // console.log("API response:", response?.data?.data);
            const totalCount = response?.data?.total_count || 0;
            setTotalRecord(totalCount)
            if (response?.status === 200 && Array.isArray(response.data.data)) {
                const detailData = response.data.data;
                setDetailReport(detailData);
                if (detailData.length > 0) {
                    setPartyId(detailData[0].party_id);
                }
                setCurrentPage(page);
                setTotalPages(Math.ceil(totalCount / recordsPerPage));
                // console.log('Math.ceil(totalCount / recordsPerPage)', Math.ceil(totalCount / recordsPerPage));

            } else {
                toast.error(response?.data?.message || "No detail report found");
                setDetailReport([]);
            }
        } catch (error) {
            console.error("Error fetching detail report:", error);
            toast.error("Something went wrong while fetching report");
            setDetailReport([]);
        }
    };

    const getCelebratedReportData = async (page = 1) => {

        setShowDetailTable(false);
        try {
            const centerlist = Array.isArray(selectedCenter)
                ? selectedCenter.join(",")
                : selectedCenter;
            const payload = {
                page_number: page,
                page_size: recordsPerPage,
                start_date: search.from_date || formattedToday,
                end_date: search.to_date || formattedToday,
                location_id: centerlist || null,

            };
            const response = await API.getPartyEventReport(payload);
            //console.log('rrrrrreeeevvve',response?.data?.total_count);
            if (response?.status === 200 && Array.isArray(response?.data?.result)) {
                setPartyEventReport(response?.data?.result);
                setTotalRecord1(response?.data?.total_count);
                setTotalPages1(Math.ceil(response?.data?.total_count / recordsPerPage));
                //console.log('dddddddddddd',Math.ceil(response?.data?.total_count / recordsPerPage))
                setCurrentPage(page);
            } else {
                setPartyEventReport([]);
                toast.error("No celebrated data found");
            }
        } catch (error) {
            toast.error("Something went wrong");
        }
    };

    const getPartyDumpReportData = async (page = 1) => {
        // setShowDetailTable(true);
        try {
            const centerlist = Array.isArray(selectedCenter)
                ? selectedCenter.join(",")
                : selectedCenter;
            const payload = {
                mobile: mobile || null,
                page: page,
                page_size: recordsPerPage,
                date_from: search.from_date || formattedToday,
                date_to: search.to_date || formattedToday,
                location_id: centerlist && centerlist.length > 0 ? centerlist : null,
            };
            const response = await API.getPartyDumpReport(payload);

            const totalCount = response?.data?.total_count || 0;
            const data = response?.data?.data || [];

            setTotalRecordPartyDump(totalCount);
            setPartyDumpData(data);

            setCurrentPageDump(page);
            setPageForDump(page);
            setTotalPagesDump(Math.ceil(totalCount / recordsPerPage));
        } catch (error) {
            console.error("Error fetching detail report:", error);
            toast.error("Something went wrong while fetching report");
            setDetailReport([]);
        }
    };

    const getPageNumbers = () => {
        const pages = [];
        const maxVisible = 5;

        const current =
            reportType === "partydump"
                ? currentPageDump
                : currentPage;

        const total =
            reportType === "partydump"
                ? totalPagesDump
                : reportType === "celebrated"
                    ? totalPages1
                    : totalPages;

        if (total <= maxVisible) {
            for (let i = 1; i <= total; i++) pages.push(i);
        } else {
            if (current <= 3) {
                pages.push(1, 2, 3, "...", total);
            } else if (current >= total - 2) {
                pages.push(1, "...", total - 2, total - 1, total);
            } else {
                pages.push(1, "...", current - 1, current, current + 1, "...", total);
            }
        }

        return pages;
    };
    const getPartyAddonsData = async (partyId, type = "activity") => {
        try {
            let is_activity = false;
            let is_addOns = false;

            if (type === "activity") {
                is_activity = true;
            } else if (type === "addons") {
                is_addOns = true;
            }
            const response = await API.getPartyActivityAddOns(partyId, is_activity, is_addOns);
            // console.log("Party AddOns/Activity Data:", response.data?.data);
            setPartyData(response.data?.data || [])
        } catch (error) {
            console.error("Error fetching party addons:", error);
        }
    };

    const downloadCSV = async () => {
        // console.log('reportType',reportType);
        try {
            const centerlist = Array.isArray(selectedCenter)
                ? selectedCenter.join(",")
                : selectedCenter;

            const pageSize =
                reportType === "celebrated"
                    ? totalRecord1
                    : reportType === "partydump"
                        ? totalRecordPartyDump
                        : totalRecord;

            const payload = {
                page_number: 1,
                page_size: pageSize,
                start_date: search.from_date || formattedPastDate,
                end_date: search.to_date || formattedToday,

                ...(reportType === "party" && {
                    center_ids: centerlist && centerlist.length > 0 ? centerlist : null,
                }),

                ...(reportType === "celebrated" && {

                    location_id: centerlist && centerlist.length > 0 ? centerlist : null,
                }),
            };

            const payload1 = {
                mobile: mobile || null,
                page: 1,
                page_size: pageSize,
                date_from: search.from_date || formattedToday,
                date_to: search.to_date || formattedToday,
                location_id: centerlist && centerlist.length > 0 ? centerlist : null,
            };

            let response;
            let fileName = "Report";
            let result;

            if (reportType === "party") {
                console.log('party', reportType);
                response = await API.getDetailReport(payload);
                result = response?.data?.data || [];
                fileName = "Party_Report";

            } else if (reportType === "celebrated") {
                console.log('celebrated', reportType);
                response = await API.getPartyEventReport(payload);
                result = response?.data?.result || [];
                fileName = "Celebrated_Report";
            }

            else if (reportType === "partydump") {
                // console.log('payload1', payload1);
                response = await API.getPartyDumpReport(payload1);
                // console.log('response', response?.data)
                result = response?.data?.data || [];
                fileName = "PartyDump_Report";
            }


            if (!result.length) {
                toast.error("No data found!");
                return;
            }

            const worksheet = XLSX.utils.json_to_sheet(result);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

            XLSX.writeFile(
                workbook,
                `${fileName}.xlsx`
            );
        } catch (error) {
            console.error("Error downloading Excel:", error);
        }
    };

    const handlePartyChange = () => {
        setReportType("party");
        setShowDetailTable(true);
        setShowDetailTable1(false);
        setShowDetailPartyDump(false);
        setSelectedCenter([]);
        setResetTrigger((p) => p + 1);
        handleClear();
    };

    const handleCelebratedChange = () => {
        setReportType("celebrated");
        setShowDetailTable(false);
        setShowDetailTable1(true);
        setShowDetailPartyDump(false)
        setSelectedCenter([]);
        setResetTrigger((p) => p + 1);
        handleClear();
    };

    const handlePartyDumpReportChange = () => {
        setReportType("partydump");
        setShowDetailTable(false);
        setShowDetailTable1(false);
        setShowDetailPartyDump(true)
        setSelectedCenter([]);
        setResetTrigger((p) => p + 1);
        handleClear();
    };

    const handleClear = () => {
        setSearch({
            searchText: "",
            from_date: formattedToday,
            to_date: formattedToday,
        });
    };

    const handleSearch = () => {
        if (reportType === "party") {
            getDetailReportData(1);
            setShowDetailTable(true);
            setShowDetailTable1(false);
            setShowDetailPartyDump(false)
        } else if (reportType === "celebrated") {
            getCelebratedReportData(1);
            setShowDetailTable(false);
            setShowDetailTable1(true);
            setShowDetailPartyDump(false)
        }
        else if (reportType === "partydump") {
            getPartyDumpReportData(1);
            setShowDetailTable(false);
            setShowDetailTable1(false);
            setShowDetailPartyDump(true)
        }
    };
    const formatHeader = (key) => {
        return key
            .replace(/_/g, " ")
            .replace(/\b\w/g, (char) => char.toUpperCase());
    };
    const columns = partyDumpData.length > 0
        ? Object.keys(partyDumpData[0])
        : [];

    const ignoreFields = ["party_id", "center_id"];

    const columnsPartyReport = detailReport.length > 0
        ? Object.keys(detailReport[0]).filter(key => !ignoreFields.includes(key))
        : [];

    const headerMap = {
        no_of_activity_guest: "Guest count (Activity)",
        no_of_food_guest: "Guest count (Food)"
    };
    return (
        <div>
            <ToastContainer />
            <div className="card mt-1" ref={tableRef}>
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h4 className="card-title mb-0">Party Summary</h4>
                </div>
                <div className="card-body p-0">
                    <div className="p-4">
                        {partySummary && Object.keys(partySummary).length > 0 ? (
                            <div className="d-flex flex-wrap justify-content-between">
                                {/* Card 1 */}
                                <div
                                    style={{
                                        backgroundColor: "#e8e8ff",
                                        padding: "15px",
                                        borderRadius: "12px",
                                        textAlign: "center",
                                        flex: "0 0 32%",
                                        marginBottom: "15px",
                                    }}
                                >
                                    <h6 className="fw-bold mb-1">{partySummary.total_party_bookings || "0"}</h6>
                                    <small>Total Party Bookings</small>
                                </div>

                                {/* Card 2 */}
                                <div
                                    style={{
                                        backgroundColor: "#fff0e6",
                                        padding: "15px",
                                        borderRadius: "12px",
                                        textAlign: "center",
                                        flex: "0 0 32%",
                                        marginBottom: "15px",
                                    }}
                                >
                                    <h6 className="fw-bold mb-1">{partySummary.total_cancelled_bookings || "0"}</h6>
                                    <small>Cancelled Bookings</small>
                                </div>

                                {/* Card 3 */}
                                <div
                                    style={{
                                        backgroundColor: "#dceeff",
                                        padding: "15px",
                                        borderRadius: "12px",
                                        textAlign: "center",
                                        flex: "0 0 32%",
                                        marginBottom: "15px",
                                    }}
                                >
                                    <h6 className="fw-semibold mb-1">{partySummary.total_rescheduled || "0"}</h6>
                                    <small>Rescheduled</small>
                                </div>

                                {/* Card 4 */}
                                <div
                                    style={{
                                        backgroundColor: "#ffe6d9",
                                        padding: "15px",
                                        borderRadius: "12px",
                                        textAlign: "center",
                                        flex: "0 0 32%",
                                        marginBottom: "15px",
                                    }}
                                >
                                    <h6 className="fw-semibold mb-1">{partySummary.total_served_parties || "0"}</h6>
                                    <small>Served Parties</small>
                                </div>

                                {/* Card 5 */}
                                <div
                                    style={{
                                        backgroundColor: "#e6fff3",
                                        padding: "15px",
                                        borderRadius: "12px",
                                        textAlign: "center",
                                        flex: "0 0 32%",
                                        marginBottom: "15px",
                                    }}
                                >
                                    <h6 className="fw-semibold mb-1">
                                        ₹ {partySummary.total_advance_collected || "0"}
                                    </h6>
                                    <small>Total Advance Collected</small>
                                </div>

                                {/* Card 6 */}
                                <div
                                    style={{
                                        backgroundColor: "#fef3c7",
                                        padding: "15px",
                                        borderRadius: "12px",
                                        textAlign: "center",
                                        flex: "0 0 32%",
                                        marginBottom: "15px",
                                    }}
                                >
                                    <h6 className="fw-semibold mb-1">
                                        ₹ {partySummary.total_collection || "0"}
                                    </h6>
                                    <small>Total Collection</small>
                                </div>
                            </div>
                        ) : (
                            <div
                                className="text-center p-4"
                                style={{
                                    backgroundColor: "#f8f9fa",
                                    borderRadius: "12px",
                                }}
                            >
                                No data available
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="card mt-3">
                <div className="card-header">
                    <h5 className="mb-0">Filter</h5>
                </div>

                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="d-flex align-items-center gap-5">

                                <label className="d-flex align-items-center gap-1 mb-0">
                                    <input
                                        type="checkbox"
                                        className="form-check-input m-0"
                                        checked={reportType === "party"}
                                        onChange={handlePartyChange}
                                    />
                                    <span>Party Details</span>
                                </label>

                                <label className="d-flex align-items-center gap-1 mb-0">
                                    <input
                                        type="checkbox"
                                        className="form-check-input m-0"
                                        checked={reportType === "celebrated"}
                                        onChange={handleCelebratedChange}
                                    />
                                    <span>Celebrated</span>
                                </label>
                                <label className="d-flex align-items-center gap-1 mb-0">
                                    <input
                                        type="checkbox"
                                        className="form-check-input m-0"
                                        checked={reportType === "partydump"}
                                        onChange={handlePartyDumpReportChange}
                                    />
                                    <span> Drop Offs</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card-body">
                    <div className="row mb-1">
                        <div className="col-md-3">

                            <CenterModal onSelectCenter={handleSelectedCenter} resetTrigger={resetTrigger} key={resetTrigger} />

                        </div>

                        <div className="col-md-3">
                            <label>From Date</label>
                            <input
                                type="date"
                                className="form-control"
                                value={search.from_date || ""}
                                //  min={formattedPastDate}
                                max={formattedToday}
                                onChange={(e) => handleFieldChange(e, "from_date")}
                            />
                        </div>

                        <div className="col-md-3">
                            <label>To Date</label>

                            <input
                                type="date"
                                className="form-control"
                                value={search.to_date || ""}
                                min={search.from_date}
                                max={
                                    search.from_date
                                        ? new Date(
                                            Math.min(
                                                new Date(search.from_date).setDate(new Date(search.from_date).getDate() + 90),
                                                new Date()
                                            )
                                        )
                                            .toISOString()
                                            .split("T")[0]
                                        : formattedToday
                                }
                                onChange={(e) => handleFieldChange(e, "to_date")}
                            />
                        </div>
                        {reportType === "partydump" && (
                            <div className="col-md-3">
                                <label>Mobile Number</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter mobile number"
                                    value={mobile}
                                    onChange={(e) => setMobile(e.target.value)}
                                />
                            </div>
                        )}
                        <div className="col-md-3 d-flex align-items-end">
                            <button
                                onClick={handleSearch}
                                className="btn btn-success"
                                type="button"
                            >
                                Search
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {showDetailTable && (
                <div className="card mt-3" ref={tableRef}>
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0">Party Details (<b>{totalRecord}</b>)</h4>

                        {totalRecord > 0 && (
                            <button className="btn btn-primary btn-sm" onClick={downloadCSV}>
                                <i className="fa fa-download"></i>
                            </button>
                        )}
                    </div>
                    <div className="card-body p-0">
                        <div className="table-responsive" style={{ whiteSpace: "nowrap" }}>
                            <table className="table table-bordered mb-0 text-center">

                                <thead className="table-light">
                                    <tr>
                                        <th>Sr No</th>

                                        {columnsPartyReport.map((key, index) => (
                                            <th key={index}>

                                                {["advance_collected", "total_bill", "final_collection"].includes(key) && (
                                                    <span className="mdi mdi-currency-rupee me-1"></span>
                                                )}
                                                {headerMap[key] || formatHeader(key)}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {detailReport.length > 0 ? (
                                        detailReport.map((row, rowIndex) => (
                                            <tr key={rowIndex}>

                                                <td>
                                                    {(currentPage - 1) * recordsPerPage + rowIndex + 1}
                                                </td>

                                                {columnsPartyReport.map((key, colIndex) => {

                                                    // ✅ Activities special case
                                                    if (key === "activities") {
                                                        return (
                                                            <td key={colIndex} className="d-flex justify-content-center align-items-center">
                                                                <span>{row[key] || 0}</span>
                                                                <span className="border-start mx-2" style={{ height: "20px" }}></span>
                                                                <i
                                                                    className="bi bi-eye"
                                                                    style={{ cursor: "pointer", color: "blue" }}
                                                                    onClick={() => getPartyAddonsData(row.party_id, "activity")}
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#myModalTaxView"
                                                                ></i>
                                                            </td>
                                                        );
                                                    }

                                                    if (key === "add_ons") {
                                                        return (
                                                            <td key={colIndex} className="d-flex justify-content-center align-items-center">
                                                                <span>{row[key] || 0}</span>
                                                                <span className="border-start mx-2" style={{ height: "20px" }}></span>
                                                                <i
                                                                    className="bi bi-eye"
                                                                    style={{ cursor: "pointer", color: "green" }}
                                                                    onClick={() => getPartyAddonsData(row.party_id, "addons")}
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#myModalTaxView"
                                                                ></i>
                                                            </td>
                                                        );
                                                    }

                                                    return (
                                                        <td key={colIndex}>
                                                            {row[key] ?? "N/A"}
                                                        </td>
                                                    );
                                                })}
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={columns.length + 1}>
                                                No data available
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <nav aria-label="Page navigation example">
                            <ul className="pagination justify-content-center mt-4">
                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => getDetailReportData(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    >
                                        Previous
                                    </button>
                                </li>

                                {getPageNumbers().map((page, index) => (
                                    <li
                                        key={index}
                                        className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
                                    >
                                        {page === "..." ? (
                                            <span className="page-link">...</span>
                                        ) : (
                                            <button
                                                className="page-link"
                                                onClick={() => getDetailReportData(page)}
                                            >
                                                {page}
                                            </button>
                                        )}
                                    </li>
                                ))}

                                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => getDetailReportData(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                    >
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>

                </div>
            )}

            {showDetailTable1 && (
                <div className="card mt-3" ref={tableRef}>
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0">Party Details (<b>{totalRecord1}</b>)</h4>

                        {totalRecord1 > 0 && (
                            <button className="btn btn-primary btn-sm" onClick={downloadCSV}>
                                <i className="fa fa-download"></i>
                            </button>
                        )}
                    </div>
                    <div className="card-body p-0">
                        <div className="table-responsive" style={{ whiteSpace: "nowrap" }}>
                            <table className="table table-bordered  mb-0 text-center">
                                <thead className="table-light">
                                    <tr>
                                        <th>#</th>
                                        <th>Center Name</th>
                                        <th>Event Name</th>
                                        <th>Host Name</th>
                                        <th>Host Mobile</th>
                                        <th>Host Email</th>
                                        <th>Birthday Child Name</th>
                                        <th>Birthday Child Gender</th>
                                        <th>Membership Name</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(partyEventReport) && partyEventReport.length > 0 ? (
                                        partyEventReport.map((item, index) => (

                                            <tr key={index}>
                                                <td>{(currentPage - 1) * recordsPerPage + index + 1}</td>
                                                <td>{item.center_name || "N/A"}</td>
                                                <td>{item.event_name || "N/A"}</td>
                                                <td>{item.host_name || "N/A"}</td>
                                                <td>{item.host_mobile || "N/A"}</td>
                                                <td>{item.host_email || "N/A"}</td>
                                                <td>{item.birthday_child_name || "N/A"}</td>
                                                <td>{item.birthday_child_gender || "N/A"}</td>
                                                <td>{item.membership_name || "N/A"}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="8">No data available</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <nav aria-label="Page navigation example">
                            <ul className="pagination justify-content-center mt-4">
                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => getCelebratedReportData(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    >
                                        Previous
                                    </button>
                                </li>

                                {getPageNumbers().map((page, index) => (
                                    <li
                                        key={index}
                                        className={`page-item ${page === currentPage ? "active" : ""
                                            } ${page === "..." ? "disabled" : ""}`}
                                    >
                                        {page === "..." ? (
                                            <span className="page-link">...</span>
                                        ) : (
                                            <button
                                                className="page-link"
                                                onClick={() => getCelebratedReportData(page)}
                                            >
                                                {page}
                                            </button>
                                        )}
                                    </li>
                                ))}

                                <li
                                    className={`page-item ${currentPage === totalPages1 ? "disabled" : ""
                                        }`}
                                >
                                    <button
                                        className="page-link"
                                        onClick={() => getCelebratedReportData(currentPage + 1)}
                                        disabled={currentPage === totalPages1}
                                    >
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            )}

            {showDetailPartyDump && (
                <div className="card mt-3" ref={tableRef}>
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0">Party Drop Off Report (<b>{totalRecordPartyDump}</b>)</h4>

                        {totalRecordPartyDump > 0 && (
                            <button className="btn btn-primary btn-sm" onClick={downloadCSV}>
                                <i className="fa fa-download"></i>
                            </button>
                        )}
                    </div>
                    <div className="card-body p-0">
                        <div className="table-responsive" style={{ whiteSpace: "nowrap" }}>
                            <table className="table table-bordered  mb-0 text-center">
                                <thead className="table-light">

                                    <tr>
                                        <th>Sr No</th>
                                        {columns.map((key, index) => (
                                            <th key={index}>{formatHeader(key)}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {partyDumpData.length > 0 ? (
                                        partyDumpData.map((row, rowIndex) => (
                                            <tr key={rowIndex}>
                                                <td>{(currentPageDump - 1) * 10 + rowIndex + 1}</td>
                                                {columns.map((key, colIndex) => (
                                                    <td key={colIndex}>
                                                        {row[key] || "N/A"}
                                                    </td>
                                                ))}
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={columns.length}>
                                                No data available
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <nav aria-label="Page navigation example">
                            <ul className="pagination justify-content-center mt-4">

                                <li className={`page-item ${currentPageDump === 1 ? "disabled" : ""}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => getPartyDumpReportData(currentPageDump - 1)}
                                        disabled={currentPageDump === 1}
                                    >
                                        Previous
                                    </button>
                                </li>

                                {getPageNumbers().map((page, index) => (
                                    <li
                                        key={index}
                                        className={`page-item ${page === currentPageDump ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
                                    >
                                        {page === "..." ? (
                                            <span className="page-link">...</span>
                                        ) : (
                                            <button
                                                className="page-link"
                                                onClick={() => getPartyDumpReportData(page)}
                                            >
                                                {page}
                                            </button>
                                        )}
                                    </li>
                                ))}

                                <li className={`page-item ${currentPageDump === totalPagesDump ? "disabled" : ""}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => getPartyDumpReportData(currentPageDump + 1)}
                                        disabled={currentPageDump === totalPagesDump}
                                    >
                                        Next
                                    </button>
                                </li>

                            </ul>
                        </nav>
                    </div>
                </div>
            )}



            <section>
                <div className="modal" id="myModalTaxView" data-bs-backdrop="static">
                    <div className="modal-dialog modal-lg" style={{ width: "800px" }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Party Activities</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="col-lg-12 grid-margin stretch-card">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <table className="table table-bordered text-center">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Name</th>
                                                            <th><span className="mdi mdi-currency-rupee"></span> Price</th>
                                                            <th>
                                                                {partyData?.[0]?.duration ? "Duration" : "Quantity"}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {Array.isArray(partyData) && partyData.length > 0 ? (
                                                            partyData.map((item, index) => (
                                                                <tr key={item.activity_id}>
                                                                    <td>{index + 1}</td>
                                                                    <td>{item.name}</td>
                                                                    <td>{item.price}</td>
                                                                    <td>{item.duration ? `${item.duration} min` : item.quantity}</td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="4">No activities found</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>



    );
};

export default PartyReport;